module.exports = __webpack_public_path__ + "./docs/img/scheme_3.53c68acd57b540f91c8c8ef63f341ac0.svg";